const mobileGalleryFix = () => {
  const productGalleries = document.querySelectorAll(".product-gallery");
  if (window.screen.availWidth < 769) {
    productGalleries.forEach(async (gallery) => {
      // console.log("comming here");

      let gallerySize = gallery.offsetHeight;
      const thumbsContainer = gallery.querySelector(
        ".product-gallery__thumbnails"
      );

      if (!thumbsContainer) return;

      // console.log("Galler size is: ", gallerySize);

      const interval = await setInterval(() => {
        if (gallerySize < 900) {
          let flkty = new Flickity(thumbsContainer);
          
          
          if (thumbsContainer.flickity) {
            thumbsContainer.flickity.destroy();
          }

          thumbsContainer.style.width = gallerySize + "px";

          flkty = new Flickity(thumbsContainer, {
            cellAlign: "left",
            contain: true,
            groupCells: 3,
            imagesLoaded: true,

            pageDots: false,
            prevNextButtons: true,

            arrowShape: window.arrowShape,
          });
          const marques = document.querySelectorAll("body.product .marquee-mobile-container .marquee-mobile");
          setTimeout(() => {
            marques.forEach(el => el.classList.add("animation-can-start"));
          }, 100)
          
          clearInterval(interval);
          
        } else {
          gallerySize = gallery.offsetHeight;
        }
      }, 200);
    });
  }
};

document.addEventListener("DOMContentLoaded", () => {
  // console.log("YO IM HERE");

  mobileGalleryFix();

  
});

window.addEventListener("resize", () => {
  setTimeout(() => {
    mobileGalleryFix();
  }, 300);
});
